import { render } from "./dotted-list-item.vue?vue&type=template&id=24e7560a"
const script = {}

import "./dotted-list-item.vue?vue&type=style&index=0&id=24e7560a&lang=css"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__